import fs from 'node:fs'
import path from 'node:path'

/**
 * Snapshot `.env.local` before Vercel CLI commands run and restore it after.
 *
 * Vercel CLI v54 writes to `.env.local` on its own with no opt-out: `vercel
 * link` injects `VERCEL_OIDC_TOKEN` (creating the file when missing) via its
 * post-link OIDC refresh, and `vercel blob create-store` runs a full
 * `env pull` over the file ("# Created by Vercel CLI" dump) after connecting
 * the store to the linked project. The BetterStart flows capture everything
 * they need (DATABASE_URL, BLOB_READ_WRITE_TOKEN) through temp-file env pulls
 * and persist those values themselves, so anything Vercel writes to
 * `.env.local` is pure pollution — restoring the snapshot keeps the file
 * BetterStart-owned.
 */
export function guardEnvLocal(cwd: string): { restore: () => void } {
  const envPath = path.join(cwd, '.env.local')
  let original: string | undefined
  try {
    original = fs.readFileSync(envPath, 'utf-8')
  } catch {
    original = undefined
  }

  return {
    restore(): void {
      try {
        const current = fs.existsSync(envPath) ? fs.readFileSync(envPath, 'utf-8') : undefined
        if (current === original) return
        if (original === undefined) {
          fs.rmSync(envPath, { force: true })
        } else {
          fs.writeFileSync(envPath, original)
        }
      } catch {
        // best effort — never let env cleanup break provisioning results
      }
    }
  }
}
